
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSensorWaterSalinityGoogle as ObiSensorWaterSalinityGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sensor-water-salinity-google.js';
 
 
 

 
 export const ObiSensorWaterSalinityGoogle = createComponent({
   react: React,
   tagName: 'obi-sensor-water-salinity-google',
   elementClass: ObiSensorWaterSalinityGoogleElement,
   events: {
     
   }
  });
 
 